import { render, staticRenderFns } from "./carbonTrading.vue?vue&type=template&id=613f6c47&"
import script from "./carbonTrading.vue?vue&type=script&lang=js&"
export * from "./carbonTrading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports